<!--
 * @Author: 
 * @Date: 2022-06-25 20:31:36
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-06 09:30:32
 * @FilePath: /Cup2Market/src/components/card/BrandCard.vue
 * @Description: 
-->
<template>
  <div
    class="flex flex-col justify-center content-center m-4"
    :style="compStyle"
  >
    <!-- <slot name="topTitle"><span class="text-center">TopTitle</span></slot> -->
    <van-image v-bind="$attrs" v-on="$listeners" />
    <slot name="title">
      <div class="card-title" :style="compWidth">
        <span>{{ $attrs.title }}</span>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: "BrandCard",
  computed: {
    // 组件根元素样式
    compAttrs() {
      const attrs = this.$attrs;
      return attrs;
    },
    compStyle() {
      const attrs = this.$attrs;
      return `width:${attrs.width}px;height:${attrs.height}`;
    },
    compWidth() {
      return this.compAttrs.width;
    },
  },
};
</script>

<style scoped lang="less">
.card-title {
  /* px-to-viewport-ignore-next */
  font-size: 11px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  // height: 11px;
  // line-height: 11px;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
